<template>
  <div>
    <div class="bg-gradient"></div>
    <div class="main-page">
      <div class="container-fluid">
        <div class="row">
          <div class="col-12">
            <div class="search-holder mt-30 search-holder-list">
              <div class="input-group">
                <input type="text" placeholder="Search Projects" @input="(e) => (Filter = e.target.value)" :value="Filter" class="search form-control" @keyup.enter="FilterData" />
                <svg v-if="Filter" @click="resetFilter" version="1.1" id="Capa_1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" x="0px" y="0px" viewBox="0 0 512.001 512.001" style="enable-background: new 0 0 512.001 512.001" xml:space="preserve" width="14" height="14" class="close r-70">
                  <g>
                    <g>
                      <path d="M284.286,256.002L506.143,34.144c7.811-7.811,7.811-20.475,0-28.285c-7.811-7.81-20.475-7.811-28.285,0L256,227.717
                            L34.143,5.859c-7.811-7.811-20.475-7.811-28.285,0c-7.81,7.811-7.811,20.475,0,28.285l221.857,221.857L5.858,477.859
                            c-7.811,7.811-7.811,20.475,0,28.285c3.905,3.905,9.024,5.857,14.143,5.857c5.119,0,10.237-1.952,14.143-5.857L256,284.287
                            l221.857,221.857c3.905,3.905,9.024,5.857,14.143,5.857s10.237-1.952,14.143-5.857c7.811-7.811,7.811-20.475,0-28.285
                            L284.286,256.002z" />
                    </g>
                  </g>
                </svg>
                <div class="input-group-append align-fix" id="button-addon4">
                  <!-- <button class="btn btn-white rounded-right" :disabled="!Filter" @click="FilterData" type="button">Go</button> -->
                  <button class="btn btn-white rounded-right" :disabled="!Filter" @click="FilterData" type="button">
                    <svg version="1.1" id="Capa_1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" x="0px" y="0px" viewBox="0 0 451 451" style="enable-background: new 0 0 451 451" xml:space="preserve">
                      <g>
                        <path d="M447.05,428l-109.6-109.6c29.4-33.8,47.2-77.9,47.2-126.1C384.65,86.2,298.35,0,192.35,0C86.25,0,0.05,86.3,0.05,192.3
                                        s86.3,192.3,192.3,192.3c48.2,0,92.3-17.8,126.1-47.2L428.05,447c2.6,2.6,6.1,4,9.5,4s6.9-1.3,9.5-4
                                        C452.25,441.8,452.25,433.2,447.05,428z M26.95,192.3c0-91.2,74.2-165.3,165.3-165.3c91.2,0,165.3,74.2,165.3,165.3
                                        s-74.1,165.4-165.3,165.4C101.15,357.7,26.95,283.5,26.95,192.3z" />
                      </g>
                    </svg>
                  </button>
                  <!-- <button v-b-toggle.sidebar-right class="filter-menu btn btn-filter btn-white" type="button">
                    <img src="@/assets/filter.svg" alt="" />
                  </button> -->
                </div>
              </div>
            </div>
            <div class="row">
              <div class="col-12">
                <span class="result-Text">{{ pageStart }} - {{ pageEnd }} of {{ total }}</span>
              </div>
            </div>
          </div>
          <!-- Enquiry Card -->
          <div class="col-12 p-0">
            <div class="card enquiry-card project-card">
              <b-list-group class="list-group-flush">
                <b-list-group-item class="project-heading">
                  <div class="row">
                    <div class="col-6 pr-1">
                      <span class="name">Project</span>
                    </div>
                    <div class="col-3 pl-1 pr-0 text-right">
                      <span class="name">Interested Brokers</span>
                    </div>
                    <div class="col-3 pl-1 text-right">
                      <span class="name">Initiate Brokers</span>
                    </div>
                  </div>
                </b-list-group-item>
                <b-list-group-item v-for="item in ProjectBrokersCount" :key="item.id">
                  <div class="row">
                    <div class="col-6 pr-1">
                      <router-link class="name ellipses underline m-0" :to="{ name: 'ProjectDetails', params: {  id: item.id }}">{{item.name}} </router-link>
                    </div>
                    <div class="col-3 pl-1 pr-0 text-right">
                      <router-link class="project-count" :to="{ name: 'InterestedBroker', params: {  id: item.id }}">{{item.interested}}</router-link>
                    </div>
                    <div class="col-3 pl-1 text-right">
                      <router-link class="btn-primary-light btn" :to="{ name: 'BrokerInitiation', params: { id: item.id }}"><svg width="8" height="11" viewBox="0 0 8 11" fill="none" xmlns="http://www.w3.org/2000/svg">
                          <path d="M3.53625 5.30375L0 1.76875L1.7675 0L7.07125 5.30375L1.7675 10.6075L0 8.83875L3.53625 5.30375Z" fill="#233445" />
                        </svg>
                      </router-link>
                    </div>
                  </div>
                </b-list-group-item>
              </b-list-group>
            </div>
          </div>
        </div>
        <paginate v-if="totalPages > 1" v-model="pageNo" :page-count="totalPages" :click-handler="goToPage" :prev-text="'Prev'" :next-text="'Next'" :prev-class="'page-item'" :prev-link-class="'page-link'" :next-class="'page-item'" :next-link-class="'page-link'" :container-class="'pagination justify-content-center'" :page-class="'page-item'" :page-link-class="'page-link'">
        </paginate>
      </div>
    </div>
  </div>
</template>
<script>
import { paramsFromQuery } from "@/assets/scripts/utility.js";
import qs from "qs";
export default {
  name: "Project",
  data() {
    return {
      ProjectBrokersCount: [],
      total: 0,
      perPage: 0,
      Filter: this.$route.query.search_query
    }
  },
  created() {
    this.FetchProjectAndIntrestedBrokers();
  },
  watch: {
    $route(to, from) {
      this.FetchProjectAndIntrestedBrokers();
    },
  },
  computed: {
    totalPages() {
      if (this.total === 0 || this.perPage === 0) {
        return 0;
      } else {
        return Math.ceil(this.total / this.perPage);
      }
    },
    pageNo: {
      get() {
        let pageNo = this.$route.query.pageNo || 1;
        return parseInt(pageNo);
      },
      set() {
        true;
      },
    },
    pageStart() {
      if (this.total === 0) {
        return 0;
      }
      return Math.max(0, (this.pageNo - 1) * this.perPage + 1);
    },
    pageEnd() {
      if (this.total === 0) {
        return 0;
      }
      return Math.min(this.total, this.pageNo * this.perPage);
    },
  },
  methods: {
    resetFilter() {
      let rQ = this.$route.query;
      this.Filter = "";
      if (rQ.search_query) {
        let {
          search_query,
          ...newQ
        } = rQ;
        this.$router.replace({
          query: newQ
        });
      }
    },
    FilterData() {
      if (this.Filter) {
        let newQ = {
          ...this.$route.query,
          search_query: this.Filter
        };
        this.$router.replace({
          query: newQ
        });
      }
    },
    goToPage(pageNo) {
      let newQ = {
        ...this.$route.query,
        pageNo
      };
      this.$router.replace({
        query: newQ
      });
    },
    FetchProjectAndIntrestedBrokers() {
      let queryP = {}
      paramsFromQuery(queryP, this.$route.query);
      this.$axios.get(`buildings/all`, {
        params: queryP,
        paramsSerializer: (params) =>
          qs.stringify(params, {
            arrayFormat: "brackets"
          }),
      }).then((res) => {
        this.ProjectBrokersCount = res.data.buildings;
        this.perPage = res.data.per_page;
        this.total = res.data.count;
      });
    }
  }
}
</script>
<style scoped>
.badge-secondary {
  color: #fff;
  background-color: #233445;
  margin-right: -10px;
}

.underline {
  text-decoration: underline;
  padding-top: 10px;
}

.float-btn {
  margin-top: 100px;
}

.btn-primary-light {
  background: rgba(35, 52, 69, 0.1);
  border-radius: 4px;
  padding: 2px 10px;
}
</style>